import React from 'react';

import { closeModal } from '@src/reduce/modals';
import { Modal } from 'antd';
import DaumPostcodeEmbed, { Address } from 'react-daum-postcode';
import { useDispatch } from 'react-redux';

import * as S from './styled';
import * as T from './type';

const PostcodeModal = ({ setFormData }: T.PostCodeModalProps) => {
  const dispatch = useDispatch();

  const close = () => {
    dispatch(closeModal('postcodeModal'));
  };

  const handleComplete = (data: Address) => {
    const kakao = (window as any).kakao;
    // 주소-좌표 변환 객체를 생성합니다
    const geocoder = new kakao.maps.services.Geocoder();
    // // 주소로 좌표를 검색합니다
    geocoder.addressSearch(
      data.address,
      function (result: { x: number; y: number }[], status: number) {
        setFormData(prev => ({ ...prev, location: { coordinates: [result[0].x, result[0].y] } }));
      },
    );

    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    setFormData(prev => ({ ...prev, address: fullAddress }));
    close();
  };

  return (
    <Modal open={true} footer={false} style={{ height: 'auto' }} onCancel={close}>
      <S.Container>
        <DaumPostcodeEmbed onComplete={handleComplete} style={{ height: '550px' }} />
      </S.Container>
    </Modal>
  );
};

export default PostcodeModal;
